import React, { useEffect } from "react";
import "./App.scss";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";

import Splash from "./container/Splash/Splash";
import LoginContainer from "./container/Login/LoginContainer";
import ResetPasswordContainer from "./container/Login/ResetPasswordContainer";
import SignupContainer from "./container/Signup/SignupContainer";
import BuildProfileContainer from "./container/BuildProfile/BuildProfileContainer";
import DashboardLayout from "./components/Dashboard/DashboardLayout";
import CouncilProfileLayout from "./components/CouncilProfile/CouncilProfileLayout";
import EditProfileLayout from "./components/EditProfile/EditProfileLayout";
import PrivateRoute from "./helpers/PrivateRoute";
import EmailVerify from "./components/Login/EmailVerify";
import PasswordRestored from "./components/Login/PasswordRestored";
import SignupAccount from "./components/Signup/SignupAccount";
import SignupVerify from "./components/Signup/SignupVerify";
import ForgotPassword from "./components/Login/ForgotPassword";
import BuildProfileSuccess from "./components/BuildProfile/BuildProfileSuccess";
import PostsMainLayout from "./container/PostsMainLayout";
import CreatePost from "./components/Posts/CreatePost";
import EditPostLayout from "./components/EditPost/EditPostLayout";
import EventLayout from "./components/Event/EventLayout";
import CreateEvent from "./components/Event/CreateEvent";
import OnBoarding from "./components/OnBoarding/OnBoarding";
import VerifyAccount from "./components/Signup/VerifyAccount";
import Users from "./components/Users/index";
import { ThemeProvider } from "styled-components";
import theme from "./theme";
import AddShortcutModal from "./components/Common/AddShortcutModal";
import { VIEW_PROFILE } from "./query/ViewProfile";
import { useLazyQuery } from "@apollo/client";
import { hasuraClient } from "./apolloClient";
import AttractionsLayout from "./components/Attractions/AttractionsLayout";
import CreateAttractionLayout from "./components/Attractions/CreateAttractionLayout";
import AttractionDetails from "./components/Attractions/AttractionDetails";
import EditAttractionLayout from "./components/Attractions/EditAttractionLayout";
import EditEvent from "./components/Event/EditEvent";
import EventDetails from "./components/Event/EventDetails";
import TransactionDetails from "./components/Dashboard/Transaction/TransactionDetails";
import SettingsLayout from "./components/Settings/SettingsLayout";
import ReferralsDetails from "./components/Settings/ReferralsDetails";
import TourMain from "./components/Tour/TourMain";
import Landing from "./landing/Landing";
import OneSignal from "react-onesignal";
import EventDetailsTable from "./components/Event/EventDetailsTable";

export const UserContext = React.createContext(null);

function App() {
  const [userContextState, setuserContextState] = React.useState({});

  const [isTourRun, setTourRun] = React.useState(false);

  const [getProfile, { data }] = useLazyQuery(VIEW_PROFILE, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });

  React.useEffect(async () => {
    let my_awesome_script = document.createElement("script");

    my_awesome_script.setAttribute(
      "src",
      `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_URL}&libraries=places`
    );

    document.head.appendChild(my_awesome_script);
    if (localStorage.getItem("jwt_token")) {
      getProfile();
    }

    if (
      localStorage.getItem("user_id") &&
      localStorage.getItem("profile_id") &&
      localStorage.getItem("jwt_token") &&
      localStorage.getItem("is_profile_setup")
    ) {
      await OneSignal.init({
        appId: process.env.REACT_APP_ONE_SIGNAL_APP_ID,
        notifyButton: { enable: true },
        serviceWorkerParam: { scope: "/push/onesignal/" },
        serviceWorkerPath: "push/onesignal/OneSignalSDKWorker.js",
        serviceWorkerUpdaterPath: "push/onesignal/OneSignalSDKUpdaterWorker.js",
        // allowLocalhostAsSecureOrigin: true,
        // subdomainName: "localhostnnee",
      }).then(() => {
        OneSignal.getSubscription((isSubscribe) => {
          OneSignal.setExternalUserId(localStorage.getItem("user_id"));
          if (!isSubscribe) {
            OneSignal.setExternalUserId(localStorage.getItem("user_id"));
            OneSignal.showNativePrompt();
            OneSignal.setSubscription(true);
          }
        });
      });
    }
    OneSignal.setExternalUserId(localStorage.getItem("user_id"));
  }, []);

  useEffect(() => {
    setTourRun(userContextState.runTour);
  }, [userContextState]);

  useEffect(() => {
    if (data) {
      if (data.users[0].council_profile) {
        localStorage.setItem("user_mail", data?.users[0]?.email);
        localStorage.setItem("user_id", data?.users[0]?.id);
        localStorage.setItem("profile_id", data?.users[0]?.council_profile?.id);
        if (data?.users[0]?.is_profile_setup) {
          localStorage.setItem(
            "is_profile_setup",
            data?.users[0]?.is_profile_setup
          );
        }
        if (data?.users[0]?.council_profile?.id) {
          localStorage.setItem(
            "profile_id",
            data?.users[0]?.council_profile?.id
          );
        }
      }
    }
  }, [data]);

  return (
    <ThemeProvider theme={theme}>
      <React.Fragment>
        <UserContext.Provider value={{ userContextState, setuserContextState }}>
          <Router>
            {isTourRun ? <TourMain /> : ""}

            <Switch>
              <Route exact path="/" component={Landing} />
              <Route exact path="/splash" component={Splash} />
              <Route exact path="/login" component={LoginContainer} />
              <Route exact path="/signup" component={SignupContainer} />
              <Route
                exact
                path="/referral-invite/:id"
                component={SignupContainer}
              />
              <Route exact path="/signup/1" component={SignupAccount} />
              <Route exact path="/signup/2" component={SignupVerify} />
              <Route
                exact
                path="/verify-account/:id"
                component={VerifyAccount}
              />
              <Route
                exact
                path="/reset-password"
                component={ResetPasswordContainer}
              />

              <Route exact path="/reset-password/2" component={EmailVerify} />

              <Route
                exact
                path="/forget-password/:id"
                component={ForgotPassword}
              />

              <Route
                exact
                path="/password-restored"
                component={PasswordRestored}
              />

              <Route
                exact
                path="/build-profile"
                component={BuildProfileContainer}
              />

              <Route
                exact
                path="/build-profile-success"
                component={BuildProfileSuccess}
              />

              <PrivateRoute
                exact
                path="/dashboard"
                component={DashboardLayout}
              />

              <PrivateRoute
                exact
                path="/council-profile"
                component={CouncilProfileLayout}
              />

              <PrivateRoute
                exact
                path="/edit-council-profile"
                component={EditProfileLayout}
              />

              <PrivateRoute exact path="/posts" component={PostsMainLayout} />

              <PrivateRoute exact path="/create-post" component={CreatePost} />

              <PrivateRoute
                exact
                path="/edit-post/:id"
                component={EditPostLayout}
              />

              <PrivateRoute exact path="/event" component={EventLayout} />

              <PrivateRoute
                exact
                path="/create-event"
                component={CreateEvent}
              />
              <PrivateRoute
                exact
                path="/edit-event/:id"
                component={EditEvent}
              />
              <PrivateRoute
                exact
                path="/event-details/:id"
                component={EventDetails}
              />

              <Route exact path="/onboarding" component={OnBoarding} />

              {/* <PrivateRoute exact path="/users" component={Users} /> */}

              {/* <Route exact path="/attractions" component={Attractions} /> */}

              <PrivateRoute exact path="/createevent" component={CreateEvent} />

              {/* <Route exact path='/eventfree' component={EventFree} />
								<Route exact path='/eventpaid' component={EventPaid} /> */}
              <PrivateRoute
                exact
                path="/attractions"
                component={AttractionsLayout}
              />
              <PrivateRoute
                exact
                path="/create-attraction"
                component={CreateAttractionLayout}
              />
              <PrivateRoute
                exact
                path="/attraction/:id"
                component={AttractionDetails}
              />

              <PrivateRoute
                exact
                path="/transaction-details"
                component={TransactionDetails}
              />

              <PrivateRoute exact path="/settings" component={SettingsLayout} />
              <PrivateRoute
                exact
                path="/settings/:id"
                component={SettingsLayout}
              />

              {/* <PrivateRoute
                exact
                path="/referrals-details"
                component={ReferralsDetails}
              /> */}

              <PrivateRoute
                exact
                path="/edit-attraction/:id"
                component={EditAttractionLayout}
              />
              <PrivateRoute
                exact
                path="/event-details-data/:id"
                component={EventDetailsTable}
              />

              <Route path="/*">
                <Redirect to="/" />
              </Route>

              <div className="App">
                <header className="App-header">
                  Welcome To WhatzOn
                  <Link to="/login">
                    <div>Login</div>
                  </Link>
                  <Link to="/dashboard">
                    <div>Dashboard</div>
                  </Link>
                  <Link to="/signup">
                    <div>Sign Up</div>
                  </Link>
                </header>
              </div>
            </Switch>

            {/* Add shortcut modal */}
            <AddShortcutModal />
          </Router>
        </UserContext.Provider>
      </React.Fragment>
    </ThemeProvider>
  );
}

export default App;
